// src/csat/csatApi.ts
import { apiClient } from "@maat/api-base";
var csatApi = {
  getEligibility: (feature) => apiClient.get("/csat/api/eligibility", { params: { feature } }),
  claimPrompt: (payload) => apiClient.post("/csat/api/prompts", payload),
  dismissPrompt: (promptId) => apiClient.patch(`/csat/api/prompts/${promptId}/dismiss`),
  submitResponse: (payload) => apiClient.post("/csat/api/responses", payload),
  adminGetSummary: (months) => apiClient.get("/csat/api/admin/summary", {
    params: months !== void 0 ? { months } : {}
  }),
  adminGetTimeseries: (params) => apiClient.get("/csat/api/admin/timeseries", { params }),
  adminListResponses: (params) => apiClient.get("/csat/api/admin/responses", { params }),
  /** Admin: what users tapped in the prompt follow-up, split by rating polarity. */
  adminGetReasons: (params) => apiClient.get("/csat/api/admin/reasons", { params })
};

export {
  csatApi
};
